export default {
  bot: 'Bot',
  agent: 'Attendant',
  status: 'Status',
  ticketsCount: 'Tickets in Attendance',
  averageResponseTime: 'Average Response Time',
  averageAttendanceTime: 'Average Attendance Time',
};
